import { Component } from '@angular/core';


export class SkyFilterInlineDemoComponent {

  public filtersActive: boolean = false;

  public showInlineFilters: boolean = false;

  public fruitType: string = 'any';

  public hideOrange: boolean = false;

  public items: any[] = [
      {
          name: 'Orange',
          description: 'A round, orange fruit.',
          type: 'citrus',
          color: 'orange'
      },
      {
          name: 'Mango',
          description: 'Delicious in smoothies, but don\'t eat the skin.',
          type: 'other',
          color: 'orange'
      },
      {
          name: 'Lime',
          description: 'A sour, green fruit used in many drinks.',
          type: 'citrus',
          color: 'green'
      },
      {
          name: 'Strawberry',
          description: 'A red fruit that goes well with shortcake.',
          type: 'berry',
          color: 'red'
      },
      {
          name: 'Blueberry',
          description: 'A small, blue fruit often found in muffins.',
          type: 'berry',
          color: 'blue'
      }

  ];

  public filteredItems: any[];

  public appliedFilters: any[] = [];

  constructor() {
    this.filteredItems = this.items.slice();
  }

  public filterButtonClicked() {
    this.showInlineFilters = !this.showInlineFilters;
  }

  public fruitTypeChange(newValue: string) {
    this.fruitType = newValue;
    this.setFilterActiveState();
  }

  public hideOrangeChange(newValue: boolean) {
    this.hideOrange = newValue;
    this.setFilterActiveState();
  }

  private setFilterActiveState() {
    this.appliedFilters = [];
    if (this.fruitType !== 'any') {
      this.appliedFilters.push({
        name: 'fruitType',
        value: this.fruitType
      });
    }
    if (this.hideOrange) {
      this.appliedFilters.push({
        name: 'hideOrange',
        value: true
      });
    }
    this.filtersActive = this.appliedFilters.length > 0;

    this.filteredItems = this.filterItems(this.items, this.appliedFilters);
  }

  private orangeFilterFailed(filter: any, item: any) {
    return filter.name === 'hideOrange' && filter.value && item.color === 'orange';
  }

  private fruitTypeFilterFailed(filter: any, item: any) {
    return filter.name === 'fruitType' && filter.value !== 'any' && filter.value !== item.type;
  }

  private itemIsShown(filters: any[], item: any[]) {
    let passesFilter = true,
        j: number;

    for (j = 0; j < filters.length; j++) {
      if (this.orangeFilterFailed(filters[j], item)) {
        passesFilter = false;
      } else if (this.fruitTypeFilterFailed(filters[j], item)) {
        passesFilter = false;
      }
    }

    return passesFilter;
  }

  private filterItems(items: any[], filters: any[]) {
      let i: number,
          passesFilter: boolean,
          result: any[] = [];

      for (i = 0; i < items.length; i++) {
        passesFilter = this.itemIsShown(filters, items[i]);
        if (passesFilter) {
          result.push(items[i]);
        }
      }

      return result;
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-filter-inline-demo',
  template: `<div>
  <sky-toolbar>
    <sky-toolbar-section>
      <sky-toolbar-item>
        <sky-filter-button
          [active]="filtersActive"
          (filterButtonClick)="filterButtonClicked()">
        </sky-filter-button>
      </sky-toolbar-item>
    </sky-toolbar-section>
  </sky-toolbar>
  <sky-filter-inline [hidden]="!showInlineFilters">
    <sky-filter-inline-item>
      <label for="sky-demo-select-type">Fruit type</label>
      <select
        id="sky-demo-select-type"
        [ngModel]="fruitType"
        (ngModelChange)="fruitTypeChange($event)">
        <option value="any">Any fruit</option>
        <option value="citrus">Citrus</option>
        <option value="berry">Berry</option>
      </select>
    </sky-filter-inline-item>
    <sky-filter-inline-item>
      <sky-checkbox
        [ngModel]="hideOrange"
        (ngModelChange)="hideOrangeChange($event)"
        >
        <sky-checkbox-label>
          Hide orange fruits
        </sky-checkbox-label>
      </sky-checkbox>
    </sky-filter-inline-item>
  </sky-filter-inline>
  <sky-repeater expandMode="none">
    <sky-repeater-item *ngFor="let item of filteredItems">
      <sky-repeater-item-title>
        {{item.name}}
      </sky-repeater-item-title>
      <sky-repeater-item-content>
        <div>
          {{item.description}}
        </div>
      </sky-repeater-item-content>
    </sky-repeater-item>
  </sky-repeater>

</div>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
